import { CardKey } from './CardKey';

import unknown from './unknown.svg';

import card2c from './simple-deck/2c.svg';
import card2d from './simple-deck/2d.svg';
import card2h from './simple-deck/2h.svg';
import card2s from './simple-deck/2s.svg';

import card3c from './simple-deck/3c.svg';
import card3d from './simple-deck/3d.svg';
import card3h from './simple-deck/3h.svg';
import card3s from './simple-deck/3s.svg';

import card4c from './simple-deck/4c.svg';
import card4d from './simple-deck/4d.svg';
import card4h from './simple-deck/4h.svg';
import card4s from './simple-deck/4s.svg';

import card5c from './simple-deck/5c.svg';
import card5d from './simple-deck/5d.svg';
import card5h from './simple-deck/5h.svg';
import card5s from './simple-deck/5s.svg';

import card6c from './simple-deck/6c.svg';
import card6d from './simple-deck/6d.svg';
import card6h from './simple-deck/6h.svg';
import card6s from './simple-deck/6s.svg';

import card7c from './simple-deck/7c.svg';
import card7d from './simple-deck/7d.svg';
import card7h from './simple-deck/7h.svg';
import card7s from './simple-deck/7s.svg';

import card8c from './simple-deck/8c.svg';
import card8d from './simple-deck/8d.svg';
import card8h from './simple-deck/8h.svg';
import card8s from './simple-deck/8s.svg';

import card9c from './simple-deck/9c.svg';
import card9d from './simple-deck/9d.svg';
import card9h from './simple-deck/9h.svg';
import card9s from './simple-deck/9s.svg';

import cardtc from './simple-deck/tc.svg';
import cardtd from './simple-deck/td.svg';
import cardth from './simple-deck/th.svg';
import cardts from './simple-deck/ts.svg';

import cardjc from './simple-deck/jc.svg';
import cardjd from './simple-deck/jd.svg';
import cardjh from './simple-deck/jh.svg';
import cardjs from './simple-deck/js.svg';

import cardqc from './simple-deck/qc.svg';
import cardqd from './simple-deck/qd.svg';
import cardqh from './simple-deck/qh.svg';
import cardqs from './simple-deck/qs.svg';

import cardkc from './simple-deck/kc.svg';
import cardkd from './simple-deck/kd.svg';
import cardkh from './simple-deck/kh.svg';
import cardks from './simple-deck/ks.svg';

import cardac from './simple-deck/ac.svg';
import cardad from './simple-deck/ad.svg';
import cardah from './simple-deck/ah.svg';
import cardas from './simple-deck/as.svg';

export const CardSet = {
  [CardKey.unknown]: unknown,
  [CardKey.c2]: card2c,
  [CardKey.d2]: card2d,
  [CardKey.h2]: card2h,
  [CardKey.s2]: card2s,

  [CardKey.c3]: card3c,
  [CardKey.d3]: card3d,
  [CardKey.h3]: card3h,
  [CardKey.s3]: card3s,

  [CardKey.c4]: card4c,
  [CardKey.d4]: card4d,
  [CardKey.h4]: card4h,
  [CardKey.s4]: card4s,

  [CardKey.c5]: card5c,
  [CardKey.d5]: card5d,
  [CardKey.h5]: card5h,
  [CardKey.s5]: card5s,

  [CardKey.c6]: card6c,
  [CardKey.d6]: card6d,
  [CardKey.h6]: card6h,
  [CardKey.s6]: card6s,

  [CardKey.c7]: card7c,
  [CardKey.d7]: card7d,
  [CardKey.h7]: card7h,
  [CardKey.s7]: card7s,

  [CardKey.c8]: card8c,
  [CardKey.d8]: card8d,
  [CardKey.h8]: card8h,
  [CardKey.s8]: card8s,

  [CardKey.c9]: card9c,
  [CardKey.d9]: card9d,
  [CardKey.h9]: card9h,
  [CardKey.s9]: card9s,

  [CardKey.ct]: cardtc,
  [CardKey.dt]: cardtd,
  [CardKey.ht]: cardth,
  [CardKey.st]: cardts,

  [CardKey.ca]: cardac,
  [CardKey.da]: cardad,
  [CardKey.ha]: cardah,
  [CardKey.sa]: cardas,

  [CardKey.cj]: cardjc,
  [CardKey.dj]: cardjd,
  [CardKey.hj]: cardjh,
  [CardKey.sj]: cardjs,

  [CardKey.cq]: cardqc,
  [CardKey.dq]: cardqd,
  [CardKey.hq]: cardqh,
  [CardKey.sq]: cardqs,

  [CardKey.ck]: cardkc,
  [CardKey.dk]: cardkd,
  [CardKey.hk]: cardkh,
  [CardKey.sk]: cardks,
};
